import React, { useState } from 'react';
import { useTranslation } from '../context/TranslationContext';
import logo from '../images/logo-small.png';

export default function Header() {
  const { t, lang, setLang } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Enable smooth scrolling behavior
  const handleLinkClick = (e, target) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.querySelector(target);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
      <nav className="container mx-auto flex items-center justify-between px-4 py-3 md:px-6">
        {/* Logo */}
        <div className="flex items-center">
          <img src={logo} alt="Qyntix" className="h-8 w-auto mr-2" />
          <span className="text-xl font-bold text-gray-800">{t('Qyntix')}</span>
        </div>

        {/* Hamburger Button */}
        <button
          className="md:hidden focus:outline-none"
          onClick={() => setMenuOpen(open => !open)}
          aria-label={menuOpen ? t('Cerrar menú') : t('Abrir menú')}
        >
          <svg className="h-6 w-6 text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d={
                menuOpen
                  ? 'M6 18L18 6M6 6l12 12'
                  : 'M4 6h16M4 12h16M4 18h16'
              }
            />
          </svg>
        </button>

        {/* Nav Links */}
        <div className={`flex-col md:flex-row md:flex items-center ${menuOpen ? 'flex' : 'hidden'} space-y-4 md:space-y-0 md:space-x-6`}
             onClick={() => setMenuOpen(false)}>
          <a
            href="#hero"
            onClick={(e) => handleLinkClick(e, '#hero')}
            className="text-gray-700 hover:text-gray-900"
          >
            {t('nav_home')}
          </a>
          <a
            href="#quienes-somos"
            onClick={(e) => handleLinkClick(e, '#quienes-somos')}
            className="text-gray-700 hover:text-gray-900"
          >
            {t('nav_about')}
          </a>
          <a
            href="#servicios"
            onClick={(e) => handleLinkClick(e, '#servicios')}
            className="text-gray-700 hover:text-gray-900"
          >
            {t('nav_services')}
          </a>
          <a
            href="#contacto"
            onClick={(e) => handleLinkClick(e, '#contacto')}
            className="text-gray-700 hover:text-gray-900"
          >
            {t('nav_contact')}
          </a>
          {/* Language selector */}
          <select
            value={lang}
            onChange={(e) => setLang(e.target.value)}
            className="border border-gray-300 rounded px-2 py-1 text-gray-700 focus:outline-none"
            aria-label={t('aria_select_language')}
          >
            <option value="es">Español</option>
            <option value="en">English</option>
          </select>
        </div>
      </nav>
    </header>
  );
}
